module.exports = __webpack_public_path__ + "static/img/brees-2004-top-image.20edda0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2004-top-image.jpg
// module id = OVRe
// module chunks = 1